import { Component, OnInit, OnDestroy } from '@angular/core';

import { navItems, TypedNavItem } from './_nav';
import { AuthService } from '../../auth.service';
import { HucuService } from '../../services/hucu.service';
import { GuardLoadingService } from '../../services/guard-loading.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public navItems: TypedNavItem[];
  isSidebarCollapsed = true;
  isSidebarVisible = true;
  messagesSidebarVisible: boolean = false;
  messagesSidebarFullScreen: boolean = false;
  hucuLoading: boolean = false;
  hucuIframeUrl: SafeResourceUrl | null = null;
  hucuNotificationIframeUrl: SafeResourceUrl | null = null;

  get guardLoading() {
    return this.guardLoadingService.loading;
  }

  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly hucuService: HucuService,
    private readonly guardLoadingService: GuardLoadingService
  ) {}

  ngOnInit(): void {
    if (!this.authService.validUser) {
      this.isSidebarVisible = false;
      return;
    }

    this.navItems = this.filterNavItems(navItems);
    
    // Subscribe to Hucu service observables
    this.hucuService.iframeUrl$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(url => {
        this.hucuIframeUrl = url;
      });

    this.hucuService.loading$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(loading => {
        this.hucuLoading = loading;
      });

    this.hucuService.notificationIframeUrl$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(url => {
        this.hucuNotificationIframeUrl = url;
      });

    this.hucuService.initializeNotificationIframe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  toggleMessagesSidebar(): void {
    this.messagesSidebarVisible = !this.messagesSidebarVisible;
    
    // Initialize iframe when opening sidebar
    if (this.messagesSidebarVisible) {
      this.hucuService.initializeIframe();
    }
  }

  onMessagesSidebarHide(): void {
    this.messagesSidebarFullScreen = false;
  }

  private filterNavItems(items: TypedNavItem[]): TypedNavItem[] {
    return items.reduce((acc: TypedNavItem[], item: TypedNavItem) => {
      const hasOwnPerm = !item.requiredPermission || this.authService.hasPermission(item.requiredPermission);

      if (item.children && item.children.length) {
        const filteredChildren = this.filterNavItems(item.children);
        if (hasOwnPerm && filteredChildren.length) {
          acc.push({ ...item, children: filteredChildren });
        }
      } else if (hasOwnPerm) {
        acc.push(item);
      }

      return acc;
    }, []);
  }
}
